// ./utils/api-endpoints/setUpEndpoints.ts

export const setUpEndpoints = {
    getAllSettings: '/api/Settings/GetAll',
    getAllSaleStatus: '/api/SaleStatus/GetAll',
    getClientDetail: '/api/Client/GetDetail',
    getAllContracts: '/api/TypeOfContract/GetAll',
    getLevelDataStatus: '/api/OrganisationStructure/LevelDataStatus',
    getAllLevels: '/api/OrganisationStructure/GetAllLevels',
    getDeptHierarchyWithChild: '/api/Department/GetDepartmentHierarchyWithChild',
    getDesignationFilter: '/api/Designation/Filter',
    getAllExternalLinks: '/api/ExternalLink/GetAll',
    getSkillSetFilter: '/api/SkillSet/Filter',
    getProjectTypeFilter: '/api/ProjectType/Filter',
    getAllRejectReasons: '/api/RejectReason/GetAll',
    getAllEmployeeStatus: '/api/EmployeeStatuses/GetAll',

    addRejectReason: '/api/RejectReason/Insert',

    deleteRejectReason: '/api/RejectReason/Delete',

    updateRejectReason: '/api/RejectReason/Update',


    addSaleStatus: '/api/SaleStatus/Insert',

    deleteSaleStatus: '/api/SaleStatus/Delete',

    updateSaleStatus: '/api/SaleStatus/Update',

    addEmployeeStatus: '/api/EmployeeStatuses/Insert',

    deleteEmployeeStatus: '/api/EmployeeStatuses/Delete',


    updateEmployeeStatus: '/api/EmployeeStatuses/Update',

    addContractType: '/api/TypeOfContract/Insert',

    updateContractType: '/api/TypeOfContract/Update',

    deleteContractType: '/api/TypeOfContract/Delete',

    addExternalLink: '/api/ExternalLink/Insert',

    updateExternalLink: '/api/ExternalLink/Update',

    deleteExternalLink: '/api/ExternalLink/Delete',

    addProjectGoals: '/api/ProjectType/Insert',

    updateProjectGoals: '/api/ProjectType/Update',

    deleteProjectGoals: '/api/ProjectType/Delete',

    addCurrency: '/api/Settings/Insert',


    addDesignation: '/api/Designation/Insert',

    updateDesignation: '/api/Designation/Update',

    deleteDesignation: '/api/Designation/Delete',

    addDepartment: '/api/Department/Insert',


    updateDepartment: '/api/Department/Update',

    deleteDepartment: '/api/Department/Delete',

    addLoyaltyPoints: '/api/Settings/Insert',

    settingsFilter:'/api/Settings/Filter',
    getCompanyInfo : '/api/ClientReg',

    updateCompanyInfo : '/api/ClientReg/Update',

    getNotifications : '/api/Notification/GetNotifications',

    createDepartmentLevels : '/api/OrganisationStructure/BulkInsert',

    updateLevels: '/api/OrganisationStructure/Update',

    addTeamNotice: '/api/Dashboard/AddTeamNotice',

    addSkills: '/api/SkillSet/Insert',


    deleteSkill: '/api/SkillSet/Delete',

    updateSkills: '/api/SkillSet/Update',


  };
